module.exports = __webpack_public_path__ + "img/ic_48_faq_up--selected.f86fccd5.svg";